module.exports = __webpack_public_path__ + "static/media/electricals.f46a523e.jpg";